module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete"
  }, [_c('field', {
    staticClass: "field autofill",
    attrs: {
      "name": _vm.name,
      "model": _vm.model,
      "label": _vm.label,
      "type": "text",
      "autocomplete": _vm.autocomplete,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        return _vm.debouncer(_vm.item[_vm.name])
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.onArrowDown($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        _vm.shouldQuery = true
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.onArrowUp($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }]
    },
    model: {
      value: (_vm.item[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.item, _vm.name, $$v)
      },
      expression: "item[name]"
    }
  }), _vm._v(" "), (_vm.results.length > 0) ? _c('ul', {
    class: _vm.classes,
    attrs: {
      "id": "autocomplete-results"
    }
  }, _vm._l((_vm.results), function(result, idx) {
    return _c('li', {
      key: idx,
      staticClass: "autocomplete-result",
      class: {
        'is-active': idx === _vm.arrowCounter
      },
      on: {
        "click": function($event) {
          return _vm.setResult(result)
        },
        "populateFields": _vm.populateFields
      }
    }, [_vm._v("\n      " + _vm._s(result.name) + " " + _vm._s(result.city) + " " + _vm._s(result.country) + "\n    ")])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49b808a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/AutoComplete.vue
// module id = 1894
// module chunks = 0